package one.primehealth.app

import androidx.lifecycle.Lifecycle
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class AppLifecycleChannel {

    private val _state = MutableStateFlow(Lifecycle.State.STARTED)

    val lifecycle: StateFlow<Lifecycle.State> = _state.asStateFlow()

    fun dispatchEvent(event: Lifecycle.Event) {
        _state.value = event.targetState
    }
}
